import { render } from "./CookieAlert.vue?vue&type=template&id=ef15f32c"
import script from "./CookieAlert.vue?vue&type=script&lang=js"
export * from "./CookieAlert.vue?vue&type=script&lang=js"

import "./CookieAlert.vue?vue&type=style&index=0&id=ef15f32c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__